import WindowStickerWeb from 'src/@carketa/vehicle_dialog/components/views/vehicle_sales_packet/WindowStickerWeb';

type VehicleDetailsSectionProps = {
  vehicle: any;
  neovin: any;
};

const VehicleWindowStickerSection = ({
  neovin,
}: VehicleDetailsSectionProps) => {
  return (
    <div id="window-sticker" className="mt-2 mb-5 w-full">
      <div style={{ overflowX: 'auto' }}>
        <WindowStickerWeb neoVin={neovin} />
      </div>
    </div>
  );
};

export default VehicleWindowStickerSection;
